import * as React from "react";
import * as __intl__ from "@frameio/i18n";
export type Text = {
    infiniteRemainingTime: string;
    left: string;
    days: (value: number) => string | React.ReactNode;
    hours: (value: number) => string | React.ReactNode;
    minutes: (value: number) => string | React.ReactNode;
    seconds: (value: number) => string | React.ReactNode;
};
export type Deps = {};
export default {
    DEFINE(_messages: Text, {}: Deps = {}): void {
        return Object.defineProperties(this, {
            /** Placeholder when remaining time is being calculated */
            infiniteRemainingTime: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "formatDuration.infiniteRemainingTime?c=1uengu6rejcrz", defaultMessage: "Calculating time left..." }));
                },
                enumerable: true,
                configurable: true
            },
            /** Suffix for time remaining (e.g. "5m left") */
            left: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "formatDuration.left?c=20g1f53isv2qb", defaultMessage: " left" }));
                },
                enumerable: true,
                configurable: true
            },
            /** Short duration in days (e.g. "2d") */
            days: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => (value: number) => __intl__.intl().formatMessage({ id: "formatDuration.days?c=25rmg3i1v634l", defaultMessage: "{value}d" }, { value: value }));
                },
                enumerable: true,
                configurable: true
            },
            /** Short duration in hours (e.g. "2h") */
            hours: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => (value: number) => __intl__.intl().formatMessage({ id: "formatDuration.hours?c=2lddah90bqyh1", defaultMessage: "{value}h" }, { value: value }));
                },
                enumerable: true,
                configurable: true
            },
            /** Short duration in minutes (e.g. "3m") */
            minutes: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => (value: number) => __intl__.intl().formatMessage({ id: "formatDuration.minutes?c=214qjbqlmdh2x", defaultMessage: "{value}m" }, { value: value }));
                },
                enumerable: true,
                configurable: true
            },
            /** Short duration in seconds (e.g. "48s") */
            seconds: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => (value: number) => __intl__.intl().formatMessage({ id: "formatDuration.seconds?c=1z38nsor85g0r", defaultMessage: "{value}s" }, { value: value }));
                },
                enumerable: true,
                configurable: true
            }
        });
    }
} as Text & {
    DEFINE(messages: Text, deps?: Deps): void;
};
